import React from 'react';
import { fmt } from '../kuroco/fmt';
import { formatDelta } from '../../utils/storeView';

const yen = (v) => fmt('currency', v);

/**
 * 店舗の下段: 参考として、店舗全体の売上（先月同時期比）と、その内訳（目標を設定した人 / 目標未設定・アシスタント）。
 * hero = utils/storeView.heroModel の結果。人数と「目標未設定の n 名を見る」は、管理者だけ（onOpenRoster も管理者にだけ渡す）。
 */
export default function StoreTotalCard({ hero, onOpenRoster }) {
  if (!hero) return null;
  const delta = formatDelta(hero.delta);
  const dir = hero.delta == null ? 'flat' : hero.delta > 0 ? 'up' : hero.delta < 0 ? 'down' : 'flat';
  const showSplit = hero.hasGoals && hero.holderShare != null;

  return (
    <section className="sv-card sv-whole" aria-label="店舗全体の売上">
      <div className="sv-whole-top">
        <div>
          <div className="sv-whole-k">参考：店舗全体の売上</div>
          <div className="sv-whole-v">{hero.sales == null ? '—' : yen(hero.sales)}</div>
        </div>
        {delta && <span className={`sv-delta sv-delta--${dir}`}>{delta} 先月同時期比</span>}
      </div>
      {showSplit && (
        <>
          <div className="sv-split" aria-hidden="true">
            <i style={{ width: `${hero.holderShare}%` }} />
          </div>
          <ul className="sv-split-rows">
            <li>
              <span className="sv-dot" />
              <span>目標設定{hero.holderCount != null ? ` ${hero.holderCount}名` : ''}</span>
              <b>
                {yen(hero.holderSales)}（{hero.holderShare}%）
              </b>
            </li>
            <li>
              <span className="sv-dot sv-dot--off" />
              <span>目標未設定・アシスタント</span>
              <b>
                {yen(hero.otherSales)}（{hero.otherShare}%）
              </b>
            </li>
          </ul>
        </>
      )}
      {hero.unsetPeople > 0 && onOpenRoster && (
        <button type="button" className="sv-whole-link" onClick={onOpenRoster}>
          <span>目標未設定の{hero.unsetPeople}名を見る</span>
          <span aria-hidden="true">›</span>
        </button>
      )}
    </section>
  );
}
